<template>
  <v-list-item dense class="transparent">
    <v-icon small :color="SelectedQuestion.id === question.id ? 'accent' : 'grey'" v-if="hasSelections">
      fa-check
    </v-icon>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <span
          class="filter-header"
          @click="setSelectedQuestion"
          :class="[SelectedQuestion.id === question.id ? 'selected' : '', hasSelections ? 'ml-1' : 'ml-4']"
          v-on="on"
        >
          {{ question.properties | titleCase }}
        </span>
      </template>
      <span>{{ question.text }}</span>
    </v-tooltip>
  </v-list-item>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  components: {},
  name: 'filter-list',
  props: ['question'],
  computed: {
    ...mapGetters(['SelectedQuestion', 'CustomerPageFilters']),
    hasSelections: function() {
      return (
        _.intersection(
          this.CustomerPageFilters.answers,
          _.map(this.question.answers, answer => answer.id)
        ).length > 0
      );
    }
  },
  methods: {
    ...mapActions(['selectQuestion']),
    setSelectedQuestion() {
      this.selectQuestion({ id: this.question.id });
    }
  },
  filters: {
    titleCase: function(string) {
      return _.words(string)
        .map(word => (word.length !== 3 ? _.capitalize(word) : word))
        .reduce((carry, word) => carry + ' ' + word, '');
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .list__tile {
  height: auto !important;
  user-select: unset;
}

::v-deep .filter-header {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.54);
  cursor: pointer;
}

::v-deep .list__tile__content {
  /*overflow: auto;*/
}

::v-deep .input-group {
  /*padding-top: 0;*/

  label {
    font-size: 13px;
  }

  .input-group__details::before {
    height: 0;
  }
}

.v-list-item--dense,
.v-list--dense .v-list-item {
  min-height: 30px;
}

.selected {
  color: #6cac1e !important;
  font-weight: 700;
}
</style>
